/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import styled from 'styled-components'
import shortid from 'shortid'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button as BaseButton,
  FormGroup,
  Label,
  Input,
  Row as BaseRow,
  Col as BaseCol,
} from 'reactstrap'

import { FONTS, COLORS } from '../../constants'

const Typography = {
  Header: styled.p`
    margin: 0px;

    position: relative;
    top: 4px;

    color: ${COLORS.PRIMARY_RED};
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.TITLE_SIZE};
  `,
}

const Button = styled(BaseButton)`
  width: fit-content;
  height: 40px;
  padding-top: 0px;
  padding-bottom: 0px;

  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
`

const Col = styled(BaseCol)`
  &:first-child {
    font-weight: bold;
  }
`

const Row = styled(BaseRow)`
  margin-bottom: 4px;

  &:nth-child(3) {
    margin-bottom: 8px;
  }
`

/**
 * @typedef {object} Props
 * @property {boolean} isOpen
 * @property {() => void} toggle
 * @property {(remark: string) => void} onConfirm
 * @property {string} code
 * @property {string} month
 * @property {object[]} unapproved_users
 */

/** @extends {Component<Props, *>} */
class SubmitModal extends Component {
  state = {
    remark: '',
  }

  /**
   * @param {React.ChangeEvent<HTMLInputElement>} e
   */
  setRemark = e => this.setState({ remark: e.target.value })

  handleCancel = () => {
    this.props.toggle()
    this.setState({ remark: '' })
  }

  handleConfirm = () => {
    this.props.toggle()
    this.props.onConfirm(this.state.remark)
    this.setState({ remark: '' })
  }

  render = () => {
    const { isOpen, toggle, code, month, unapproved_users } = this.props
    return (
      <Modal size="lg" isOpen={ isOpen } toggle={ toggle }>
        <ModalHeader toggle={ toggle }>
          <Typography.Header>Submit Project Profit Sheet</Typography.Header>
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Row noGutters>
              <Col xs={ 4 }>Project Code</Col>
              <Col xs={ 8 }>{code}</Col>
            </Row>
            <Row noGutters>
              <Col xs={ 4 }>Submit Month</Col>
              <Col xs={ 8 }>{month}</Col>
            </Row>
            <Row noGutters>
              <Col xs={ 4 }>Unapproved Timesheets</Col>
              <Col xs={ 8 }>
                {unapproved_users.length > 0
                  ? unapproved_users.map(u => (
                    <div key={ shortid.generate() }>
                        ({u.nick_name}) {u.first_name} {u.last_name}
                    </div>
                  ))
                  : '-'}
              </Col>
            </Row>
            <Label for="exampleText">Remark (Max 500 Character)</Label>
            <Input type="textarea" value={ this.state.remark } onChange={ this.setRemark } />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={ this.handleCancel }>
            Cancel
          </Button>
          <Button color="success" onClick={ this.handleConfirm }>
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default SubmitModal



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/SubmitModal.jsx